<template>
  <div class="footer-page">
    <div class="code-container" style="border: none">
      <div class="code-item">
        <p>中国宣纸股份有限公司</p>
        <div style="display: flex">
          <div class="item" data-aos="fade-up">
            <img @click="goHx" style="width: 110px;height: 98px;cursor: pointer" src="@/assets/images/xz-gw-2.png" alt="" />
          </div>
          <div class="item" data-aos="fade-up">
            <img src="@/assets/images/xz-wx.png" alt="" />
            <span>微信公众号</span>
          </div>
          <div class="item" data-aos="fade-up">
            <img src="@/assets/images/xz-wb.png" alt="" />
            <span>微博</span>
          </div>
          <div class="item" data-aos="fade-up">
            <img src="@/assets/images/xz-xhs.png" alt="" />
            <span>小红书</span>
          </div>
        </div>
      </div>
      <div class="code-item">
        <p>安徽红星守创宣纸销售有限公司</p>
        <div style="display: flex">
          <div class="item" data-aos="fade-up">
            <img src="@/assets/images/hxsc-gzh.png" alt="" />
            <span>微信公众号</span>
          </div>
          <div class="item" data-aos="fade-up">
            <img src="@/assets/images/hxsc-sph.png" alt="" />
            <span>微信视频号</span>
          </div>
          <div class="item" data-aos="fade-up">
            <img src="@/assets/images/hxsc-bilibli.png" alt="" />
            <span>bilibili</span>
          </div>
        </div>
      </div>
      <div class="code-item">
        <p>安徽红星文化旅游发展有限公司</p>
        <div style="display: flex">
<!--          <div class="item" data-aos="fade-up">-->
<!--            <img src="@/assets/images/hxwl-gzh.png" alt="" />-->
<!--            <span>微信公众号</span>-->
<!--          </div>-->

          <div class="item" data-aos="fade-up">
            <img src="@/assets/images/hongxing_code2.png" alt="" />
            <span>微信公众号</span>
          </div>
        </div>
      </div>
    </div>
    <div class="code-container">
      <div class="code-item">
        <p>安徽红星文化创意有限公司</p>
        <div style="display: flex">
          <div  class="item" data-aos="fade-up">
<!--            <img src="@/assets/images/hxwl-wxh.png" alt="" />-->
<!--            <span>微信号</span>-->
          </div>
        </div>
      </div>
      <div class="code-item">
        <p>安徽红星新材料科技有限公司</p>
        <div style="display: flex">
          <div  class="item" data-aos="fade-up">
            <!--            <img src="@/assets/images/hxwl-wxh.png" alt="" />-->
            <!--            <span>微信号</span>-->
          </div>
        </div>
      </div>
      <div class="code-item" style="opacity: 0;">
        <p>安徽红星新材料科技有限公司</p>
        <div style="display: flex">
          <div  class="item" data-aos="fade-up">
            <!--            <img src="@/assets/images/hxwl-wxh.png" alt="" />-->
            <!--            <span>微信号</span>-->
          </div>
        </div>
      </div>
    </div>
    <div class="desc" style="margin-bottom: 17px">
      <p>
        <span>中国宣纸博物馆版权所有 </span>
        <span>备案号：<a href="http://beian.miit.gov.cn/" target="_blank">皖ICP备10200970号-1</a> </span>
      </p>
      <p>网站浏览人数: {{ amount }}</p>
    </div>
    <div class="desc">
      <p>技术支持: 北京雅昌艺术数据有限公司</p>
    </div>
    <div @click="toTop" class="to-top">
      <img src="@/assets/images/to-top.png" alt="">
    </div>
  </div>
</template>
<script>
import { getAmountRequest } from "@/api/home";

export default {
  data() {
    return {
      amount: 0
    }
  },
  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    goHx() {
      window.open("http://www.hongxingxuanpaper.com.cn","_blank")
    }
  },
  created() {
    getAmountRequest().then(res => {
      this.amount = res.result
    })
  }
}
</script>
<style lang="scss" scoped>
.footer-page {
  position: relative;
  background: #c6a669;
  padding: 51px 120px 41px;
  font-family: PingFang SC;
  .desc {
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      font-size: 14px;
    }
    a {
      color: black;
      text-decoration: none;
    }
  }
  .code-container {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    padding-bottom: 25px;
    margin-bottom: 30px;
    .code-item {
      flex: 1;
      margin-right: 120px;
      &:last-child {
        margin-right: 0;
      }
      p {
        font-weight: 500;
        font-size: 20px;
        color: #222222;
        line-height: 32px;
        margin-bottom: 21px;
      }
      .item {
        margin-right: 40px;
        &:last-child {
          margin-right: 0;
        }
        img {
          display: block;
          height: 78px;
          margin-bottom: 15px;
        }
        span {
          display: block;
          text-align: center;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 20px;
        }
      }
    }
  }
  .to-top {
    position: absolute;
    width: 41px;
    height: 41px;
    img {
      width: 100%;
      height: 100%;
      display:block
    }
    right: 20px;
    bottom: 20px;
    cursor: pointer;
  }
}

</style>
